/** Elapsed time between database timestamps, which are UTC when no zone is present. */
export function formatRunTime(start: string, finish?: string | null): string | null {
  if (!start || !finish) return null;
  const timestamp = (value: string) => {
    const iso = value.trim().replace(" ", "T");
    return Date.parse(/(?:Z|[+-]\d{2}:?\d{2})$/i.test(iso) ? iso : `${iso}Z`);
  };
  const elapsed = timestamp(finish) - timestamp(start);
  if (!Number.isFinite(elapsed) || elapsed < 0) return null;
  const seconds = Math.floor(elapsed / 1000);
  if (seconds < 1) return "Less than 1 second";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return [hours ? `${hours}h` : "", minutes ? `${minutes}m` : "", `${seconds % 60}s`]
    .filter(Boolean).join(" ");
}
